module.exports = __webpack_public_path__ + "img/retail.7aabf6d3.svg";